'use strict';

var createBucketsFn = require('./fn-buckets').createBucketsFn;

var FN_NAME = 'jenks';

module.exports = function (datasource) {
  return createBucketsFn(datasource, FN_NAME, '>');
};

module.exports.fnName = FN_NAME;



//////////////////
// WEBPACK FOOTER
// ./~/turbo-carto/src/fn/fn-buckets-jenks.js
// module id = 2089
// module chunks = 6